import { useState } from 'react'
import { Box, Button, type ITabItem, Tabs, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { ClientsPath } from 'entities/ExportRouters'
import { ActiveClientsTab } from 'pages/clients/ui/ActiveClients/ActiveClientsTab'
import { PendingClientsTab } from 'pages/clients/ui/PendingClients/PendingClientsTab'
import styles from './styles.module.scss'

const tabs: ITabItem[] = [
  {
    name: 'Active',
    key: 'active',
  },
  {
    name: 'Pending',
    key: 'pending',
  },
]

export const ClientsPage = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].key)

  return (
    <div className={styles.wrap}>
      <Box display='flex' justifyContent='space-between' padding='64px 20px 42px'>
        <Typography variant='heading-lg' ariaLabel='Clients_title'>
          Clients
        </Typography>
        <Button
          text='New client'
          iconProps={{ icon: 'add' }}
          size='medium'
          onClick={() =>
            uiStore.changeRoute({
              path: ClientsPath.create,
            })
          }
        />
      </Box>
      <div className={styles.navBar}>
        <Tabs
          tabs={tabs}
          activeTabKey={activeTab}
          handleSelectTab={(tab) => setActiveTab(tab.key)}
          tabsClassName={styles.navBarTabs}
        />
        {activeTab === 'active' && <ActiveClientsTab />}
        {activeTab === 'pending' && <PendingClientsTab />}
      </div>
    </div>
  )
}
